import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { useVaccinationChartsDataContext } from './hooks/useVaccinationChartsDataContext';

export const TotalVaccinationByImmunoBiological = () => {
    const { chartData } = useVaccinationChartsDataContext();

    return (
        <SimpleBars
            title={'Vacinas aplicadas por tipo imunobiológico (5 maiores)'}
            horizontal={true}
            subtitles={chartData?.totalVaccinationByImmunoBiological?.map(
                (item) => item.description
            )}
            values={chartData?.totalVaccinationByImmunoBiological?.map(
                (item) => item.total || 0
            )}
        />
    );
};
